import { IconDotGrid1x3Vertical } from 'central-icons/IconDotGrid1x3Vertical';
import classNames from 'classnames';
import { useParams, useSearchParams } from 'react-router-dom';

import { Loading, PageTitles, WILSON_CLIENT_NAMES } from '@revelio/core';
import { IconButton, Menu, MenuButton } from '@revelio/ui';

import { useBrand } from '../../shared/branding/brand-provider';
import { showAlertDialog } from '../../shared/components/alert-dialog';
import { useEffectiveUserId } from '../adminRewrite/impersonation/useEffectiveUserId';
import DashboardPage from '../DashboardPage';
import { MiddlewareReportMenuList } from './components/mw-report-menu-list';
import { ReportIframe } from './components/report-iframe';
import { useAllReports } from './hooks/use-all-reports';
import styles from './report-page.module.css';

const ReportPage = () => {
  const params = useParams();
  const [queryParams] = useSearchParams();
  const brand = useBrand();

  const effectiveUserId = useEffectiveUserId();
  const reportUserId = queryParams.get('userId') || effectiveUserId || '';
  const { reports, fetching } = useAllReports({
    userId: reportUserId,
  });
  // @ts-expect-error noUncheckedIndexedAccess
  const report = reports.find((r) => r.id === params.id);

  const reportsLabel = PageTitles.REPORTS_STATUS;

  if (fetching || !report || !report.link) {
    return (
      <div className={classNames(styles.message, styles.statusMessage)}>
        {!fetching ? (
          `Sorry, we couldn't find the requested report.`
        ) : (
          <Loading />
        )}
      </div>
    );
  }

  return (
    <DashboardPage
      title={[reportsLabel, report?.name || '']}
      loading={false}
      topRight={
        report &&
        report.reportType !== 'GeneratedByRevelio' && (
          <Menu>
            <MenuButton>
              <IconButton
                aria-label="Actions"
                className={styles.actionsButton}
                icon={
                  <IconDotGrid1x3Vertical
                    size="1em"
                    className={styles.actionsIcon}
                    data-testid="reports_status_menu_button"
                  />
                }
                size="sm"
                shape="squared"
              />
            </MenuButton>
            <MiddlewareReportMenuList
              side="left"
              report={report}
              onActionTriggered={(action) => {
                if (action === 'refresh') {
                  showAlertDialog({
                    alertType: 'actionless',
                    isOpen: true,
                    headerText: 'Report Refreshing',
                    bodyContent: (
                      <span>
                        This report is being regenerated and will take a few
                        minutes. You may leave this page.
                      </span>
                    ),
                  });
                } else if (action === 'delete') {
                  showAlertDialog({
                    alertType: 'actionless',
                    isOpen: true,
                    headerText: 'Report Deleted Successfully',
                    bodyContent: (
                      <span>
                        This report has been deleted. You may now leave the
                        page.
                      </span>
                    ),
                  });
                }
              }}
            />
          </Menu>
        )
      }
    >
      <ReportIframe
        link={
          WILSON_CLIENT_NAMES.has(brand.clientName) &&
          !/[?&]cover=wilson(?:&|$)/.test(report.link)
            ? `${report.link}${report.link.includes('?') ? '&' : '?'}cover=wilson`
            : report.link
        }
      />
    </DashboardPage>
  );
};

export default ReportPage;
